<ng-container screenAnalytics="location-template-features">
    <div class="modal-header no-icon">
        <h3 class="modal-title">Use Location Template</h3>
        <enhanced-help-switch></enhanced-help-switch>
        <button
            type="button"
            class="close pull-right"
            aria-label="Close"
            (click)="hide()"
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body max-height">
        <div class="horizontal-container" style="height: 100%">
            <div class="fcol-4 vertical-container template-features-list">
                <enhanced-help componentName="screen" [compact]="true">
                </enhanced-help>
                <div
                    class="alert alert-warning top-buffer"
                    role="alert"
                    *ngIf="replacesExisting"
                >
                    Your existing mission location will be replaced with the
                    selected features.
                </div>
                <div class="form-group top-buffer">
                    <label class="control-label"> Location Template </label>
                    <ng-select
                        name="templateSelect"
                        bindValue="id"
                        bindLabel="name"
                        [items]="templates"
                        [(ngModel)]="selectedTemplateId"
                        [ngModelOptions]="{ standalone: true }"
                        [clearable]="false"
                        [readonly]="working"
                        (change)="onTemplateChanged($event)"
                        appendTo="body"
                    >
                        <ng-template
                            ng-option-tmp
                            let-item="item"
                            let-index="index"
                        >
                            {{ item.name }}
                        </ng-template>
                        <ng-template
                            ng-label-tmp
                            let-item="item"
                            let-index="index"
                        >
                            {{ item.name }}
                        </ng-template>
                    </ng-select>
                </div>

                <h4 class="primary-heading">Features to include</h4>
                <div class="horizontal-container center-children">
                    <span class="text-muted fill">
                        {{ selectedCount }} of {{ template.features.length }}
                        features selected
                    </span>
                    <button
                        type="button"
                        class="btn btn-link btn-sm"
                        [disabled]="working"
                        (click)="selectAll()"
                    >
                        Select all
                    </button>
                    <button
                        type="button"
                        class="btn btn-link btn-sm"
                        [disabled]="working"
                        (click)="selectNone()"
                    >
                        Select none
                    </button>
                </div>

                <p
                    class="text-muted top-buffer"
                    *ngIf="template.features.length === 0"
                >
                    This location template has no features.
                </p>

                <ng-container *ngFor="let section of sections">
                    <h5 class="section-heading">
                        <span class="checkbox no-margin">
                            <label>
                                <input
                                    type="checkbox"
                                    [checked]="isSectionSelected(section)"
                                    [disabled]="working"
                                    (change)="toggleSection(section)"
                                />
                                <span class="cr">
                                    <i
                                        class="cr-icon glyphicon glyphicon-ok"
                                    ></i>
                                </span>
                                {{ section.name }}
                            </label>
                        </span>
                        <div></div>
                        <span class="left-buffer">
                            {{ countSelected(section) }} of
                            {{ section.rows.length }}
                        </span>
                    </h5>
                    <div
                        class="checkbox left-indent"
                        *ngFor="let row of section.rows"
                    >
                        <label>
                            <input
                                type="checkbox"
                                [checked]="selectedIndexes.has(row.index)"
                                [disabled]="working"
                                (change)="toggleFeature(row.index)"
                            />
                            <span class="cr">
                                <i class="cr-icon glyphicon glyphicon-ok"></i>
                            </span>
                            {{ row.name }}
                            <div
                                class="text-muted small"
                                *ngIf="row.categoryName"
                            >
                                {{ row.categoryName }}
                            </div>
                        </label>
                    </div>
                </ng-container>
            </div>
            <div class="fcol-8 vertical-container template-features-map">
                <flyfreely-map
                    #map
                    class="fill"
                    [organisationId]="organisationId"
                    [features]="previewFeatures"
                    [simplifiedMap]="true"
                    [showFeatureSelection]="false"
                    [requireCtrlToZoom]="true"
                    (featuresLoaded)="map.zoomToAllFeatures(false)"
                ></flyfreely-map>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-default" (click)="cancel()">
            Cancel
        </button>
        <button
            type="button"
            class="btn btn-primary"
            [disabled]="working || selectedCount === 0"
            (click)="apply()"
        >
            Add {{ selectedCount }}
            {{ selectedCount === 1 ? 'feature' : 'features' }}
        </button>
    </div>
    <ngx-loading [show]="working"></ngx-loading>
</ng-container>
